__turbopack_context__.v({
  "className": "inter_e1bfe858-module__Yp6NIa__className",
});
